<template>
  <b-container>
    <div v-if="article.titre">
      <b-row>
        <b-col cols="9"><h2>{{ article.titre }}</h2></b-col>
        <b-col cols="3" class="text-right">
          <span v-for="cat in categories" :key="'cat-' + cat" class="badge badge-info ml-1">{{ cat }}</span>
        </b-col>
      </b-row>
    </div>

    <div v-if="article.description" class="my-2">
      <p>{{ article.description }}</p>
    </div>

    <div class="article-body" v-html="article.html"></div>
  </b-container>
</template>

<script>
import { getArticle } from "@/api";

export default {
  name: "Article",
  data() {
    return {
      article: {}
    };
  },
  computed: {
    categories() {
      const cat = this.article.categorie;
      if (!cat) return [];
      if (Array.isArray(cat)) return cat;
      return cat.split(",").map(s => s.trim()).filter(Boolean);
    }
  },
  methods: {
    load() {
      getArticle(this.$route.params.id, this.$i18n.locale).then(response => {
        this.article = response.data.article || {};
      });
    }
  },
  watch: {
    "$route.params.id"() {
      this.load();
    },
    "$i18n.locale"() {
      this.load();
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style scoped>
.article-body ::v-deep table {
  width: 100%;
  border-collapse: collapse;
  margin: 1.2em 0;
  font-size: 0.95em;
}

.article-body ::v-deep th {
  background-color: #4a90c4;
  color: #fff;
  font-weight: 600;
  padding: 8px 12px;
  text-align: left;
  border: 1px solid #3a7aaa;
}

.article-body ::v-deep td {
  padding: 6px 12px;
  border: 1px solid #cde;
  vertical-align: top;
}

.article-body ::v-deep tr:nth-child(even) td {
  background-color: #eef5fb;
}

.article-body ::v-deep tr:hover td {
  background-color: #dceefb;
}

.article-body ::v-deep code {
  background-color: #f0f4f8;
  padding: 1px 5px;
  border-radius: 3px;
  font-family: monospace;
  font-size: 0.92em;
}

.article-body ::v-deep pre {
  background-color: #f0f4f8;
  padding: 12px 16px;
  border-radius: 4px;
  overflow-x: auto;
}

.article-body ::v-deep blockquote {
  background: #dbf4f9;
  border-left: 4px solid #1547ff;
  margin: 1em 0;
  padding: 8px 16px;
}
</style>
